export default __webpack_public_path__ + "static/medium.1f916b67b799cf2a806d762bc5f9f6a9.svg";